import React, { useState } from "react";
import { Modal, Button, Table, Row, Col } from "reactstrap";

const BankerPlotDetails = ({
  details,
  state,
  district,
  full_name,
  phone_number,
  unit,
}) => {
  return (
    <Row>
      <Col lg="12" sm="12">
         
          <Table className="table mb-2" hover>
                <tbody>
                <tr>
                    <th>Farmer Name: </th>
                    <td>{full_name}</td>
                  </tr>
                
                  <tr>
                    <th>Phone Number: </th>
                    <td>{phone_number}</td>
                  </tr>
                 
                  <tr>
                    <th> State: </th>
                    <td>{state}</td>
                  </tr>
                
                  <tr>
                    <th>District: </th>
                    <td>{district}</td>
                  </tr>
                  <tr>
                    <th> Landmark: </th>
                    <td>{details.land_mark}</td>
                  </tr>
                  <tr>
                    <th>Area : </th>
                    <td>
                    {details.calculated_area} {unit}</td>
                  </tr>
                
                 
                </tbody>
              </Table>
          </Col>
    </Row>
  );
};

export default BankerPlotDetails;


